import Helmet from 'react-helmet'
import config from '../config'

interface Props {
  title: string
  description?: string
}

export default function ViewTitle(props: Readonly<Props>) {
  return (
    <Helmet>
      <title>{`${config.siteTitle} | ${props.title}`}</title>
      <meta name="description" content={props.description} />
    </Helmet>
  )
}

ViewTitle.defaultProps = {
  description: ''
}
